export default __webpack_public_path__ + "images/0x54016a4848a38f257b6e96331f7404073fd9c32c.png";